export default __webpack_public_path__ + "static/media/Bra-related chafing.af3e4d02.png";